import type { CreateUserInput, Page, UserListQuery } from '@chukua/common';
import { api } from '../../lib/api';
import { toListParams } from '../../lib/list-params';

export interface UserListItem {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  isActive: boolean;
  roles: string[];
  lastLoginAt: string | null;
}

export function listUsers(query: UserListQuery): Promise<Page<UserListItem>> {
  return api<Page<UserListItem>>(`/users?${toListParams(query)}`);
}

export async function createUser(input: CreateUserInput): Promise<void> {
  await api<void>('/users', { method: 'POST', body: JSON.stringify(input) });
}

export async function setUserRoles(id: string, roles: string[]): Promise<void> {
  await api<void>(`/users/${id}/roles`, { method: 'PATCH', body: JSON.stringify({ roles }) });
}

export async function resetUserPassword(id: string, password: string): Promise<void> {
  await api<void>(`/users/${id}/reset-password`, { method: 'POST', body: JSON.stringify({ password }) });
}

export async function deactivateUser(id: string): Promise<void> {
  await api<void>(`/users/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateUser(id: string): Promise<void> {
  await api<void>(`/users/${id}/reactivate`, { method: 'POST' });
}

export function getUser(id: string): Promise<UserListItem> {
  return api<UserListItem>(`/users/${id}`);
}
